export { default } from './MoreFeatureModal';
export type { MoreFeatureModalProps } from './types';
